import styles from './Spinner.module.css'

export function Spinner({size = 20, thickness = 2, color}) {
  return (
    <span
      className={styles.spinner}
      role="progressbar"
      style={{
        width: size,
        height: size,
        borderWidth: thickness,
        ...(color ? {color} : {}),
      }}
    />
  )
}
